import { Unit } from '../../../../shared/common/units';
import { UnitsAdaptee } from '../units.model';

export class ConsumptionChartsUnitsAdaptee implements UnitsAdaptee {
  constructor() {}

  standardizeUnit(unit: Unit | string): string {
    return unit;
  }
}
